export const socialLinks = [
  {
    name: 'LinkedIn',
    href: 'https://linkedin.com/company/envirotech-solutions',
    icon: 'linkedin',
    ariaLabel: 'Visit our LinkedIn page',
  },
  {
    name: 'Twitter',
    href: 'https://twitter.com/envirotech_sol',
    icon: 'twitter',
    ariaLabel: 'Follow us on Twitter',
  },
  {
    name: 'Facebook',
    href: 'https://facebook.com/envirotechsolutions',
    icon: 'facebook',
    ariaLabel: 'Like us on Facebook',
  },
  {
    name: 'Instagram',
    href: 'https://instagram.com/envirotech_solutions',
    icon: 'instagram',
    ariaLabel: 'Follow us on Instagram',
  },
];

export const contactMethods = [
  {
    type: 'phone',
    label: 'Call Us',
    value: '+91-9390444004',
    href: 'tel:+919390444004',
    icon: '📞',
  },
  {
    type: 'email',
    label: 'Email Us',
    value: 'terraenvironlabs@gmail.com',
    href: 'mailto:terraenvironlabs@gmail.com',
    icon: '✉️',
  },
  {
    type: 'whatsapp',
    label: 'WhatsApp',
    value: '+91-7037733026',
    href: 'https://wa.me/917037733026',
    icon: '💬',
  },
];